import { render, staticRenderFns } from "./SingleReferral.vue?vue&type=template&id=45d36536&scoped=true&"
import script from "./SingleReferral.vue?vue&type=script&lang=js&"
export * from "./SingleReferral.vue?vue&type=script&lang=js&"
import style0 from "./SingleReferral.vue?vue&type=style&index=0&id=45d36536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d36536",
  null
  
)

export default component.exports